import {Component, effect, inject, input, output, ChangeDetectionStrategy} from "@angular/core"
import {LocalPreviewRenderingService} from "@app/common/services/rendering/local-preview-rendering.service"
import {TemplateSceneViewerOptionsComponent} from "@app/template-editor/components/template-scene-viewer-options/template-scene-viewer-options.component"
import {ThreeTemplateSceneViewerComponent} from "@app/template-editor/components/three-template-scene-viewer/three-template-scene-viewer.component"
import {BlenderConnectorService} from "@app/template-editor/services/blender-connector.service"
import {SceneManagerService} from "@app/template-editor/services/scene-manager.service"
import {TypedImageData} from "@cm/utils"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-debug-menu",
    imports: [TemplateSceneViewerOptionsComponent],
    templateUrl: "./debug-menu.component.html",
    styleUrl: "./debug-menu.component.scss",
    providers: [LocalPreviewRenderingService, BlenderConnectorService],
})
export class DebugMenuComponent {
    readonly $threeViewer = input.required<ThreeTemplateSceneViewerComponent>({alias: "threeViewer"})
    readonly localSceneManagerService = inject(SceneManagerService)
    readonly localPreviewRenderingService = inject(LocalPreviewRenderingService)
    readonly previewImageDataChanged = output<TypedImageData | null>()
    readonly overlayPreviewImageDataChanged = output<boolean>()

    constructor() {
        effect(() => {
            const nodes = this.localSceneManagerService.$scene()
            if (this.localSceneManagerService.$currentlyModifyingScene()) return
            this.localPreviewRenderingService.$sceneNodes.set(nodes)
        })

        effect(() => {
            const viewer = this.$threeViewer()
            if (!viewer) return
            const {width, height, pixelRatio} = viewer.$renderDimensions()
            const resolutionScale = pixelRatio * 1
            this.localPreviewRenderingService.$size.set([width * resolutionScale, height * resolutionScale])
        })

        effect(() => {
            const viewer = this.$threeViewer()
            if (!viewer) return
            const viewCamera = viewer.$viewCamera()
            this.localPreviewRenderingService.$cameraOverride.set(viewCamera)
        })

        effect(() => {
            if (this.localSceneManagerService.$currentlyModifyingScene()) this.previewImageDataChanged.emit(null)
            this.previewImageDataChanged.emit(this.localPreviewRenderingService.$previewImageData())
        })

        effect(() => {
            this.overlayPreviewImageDataChanged.emit(this.localPreviewRenderingService.$overlayHelpers())
        })
    }
}
